export enum TermsDialogTab {
  TermsAndConditions = 'terms-and-conditions',
  PrivacyPolicy = 'privacy-policy'
}
